import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleModalModule } from 'ngx-simple-modal';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './component/organisms/footer/footer.component';
import { HeaderComponent } from './component/organisms/header/header.component';
import { TopComponent } from './component/pages/top/top.component';
import { ContactComponent } from './component/pages/contact/contact.component';
import { ContactModule } from './component/pages/contact/contact.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClient,
  HttpClientJsonpModule,
  HttpClientModule,
} from '@angular/common/http';
import { NgMessageComponent } from './component/molecules/ng-message/ng-message.component';
import { CompleteComponent } from './component/pages/complete/complete.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TitleComponent } from './component/atom/title/title.component';
import { ContactFormComponent } from './component/organisms/contact-form/contact-form.component';
import { IgxChipsModule, IgxIconModule } from 'igniteui-angular';
import { CheckboxComponent } from './component/atom/checkbox/checkbox.component';

import { LoadingComponent } from './component/atom/loading/loading.component';
import { PagingSearchComponent } from './component/molecules/paging-search/paging-search.component';
import { InputComponent } from './component/atom/input/input.component';
import { TextareaComponent } from './component/atom/textarea/textarea.component';
import { SelectboxComponent } from './component/atom/selectbox/selectbox.component';
import { RadioboxComponent } from './component/atom/radiobox/radiobox.component';
import { AboutComponent } from './component/pages/about/about.component';
import { SnackbarComponent } from './component/atom/snackbar/snackbar.component';
import { ManagementComponent } from './component/pages/management/management.component';
import { ServiceComponent } from './component/pages/service/service.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    TopComponent,
    ContactComponent,
    NgMessageComponent,
    CompleteComponent,
    TitleComponent,
    ContactFormComponent,
    CheckboxComponent,
    LoadingComponent,
    PagingSearchComponent,
    InputComponent,
    TextareaComponent,
    SelectboxComponent,
    RadioboxComponent,
    AboutComponent,
    SnackbarComponent,
    ManagementComponent,
    ServiceComponent,
  ],
  imports: [
    SimpleModalModule,
    BrowserModule,
    AppRoutingModule,
    ContactModule,
    EditorModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    IgxChipsModule,
    IgxIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      defaultLanguage: 'en',
    }),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(translate: TranslateService) {
    translate.use('en');
  }
}
